import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import auditData from '../datas/new-to-old-audit'
export default {
  bringNewRewardList (ctx, data) {
    return fetch.bringNewRewardList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.bringNewRewardList(result.data)
      return result
    })
  },
  bringNewRewardListStatistics (ctx, data) {
    return fetch.bringNewRewardListStatistics(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.bringNewRewardList(result.data)
      return result
    })
  },
  bringNewRewardStatistics (ctx, data) {
    return fetch.bringNewRewardStatistics(data).then(res => {
      return res.data
    })
  },
  bringNewRewardStatisticsSaler (ctx, data) {
    return fetch.bringNewRewardStatisticsSaler(data).then(res => {
      return res.data
    })
  },
  BringNewAuditExport (ctx, data) {
    return fetch.BringNewAuditExport(data).then(res => {
      return res.data
    })
  },
  approvalByBatchBringNew (ctx, data) {
    return fetch.approvalByBatchBringNew(data).then(res => {
      let result = auditData.approvalByBatchBringNew(res.data)
      return result
    })
  },
  rejectByBatchBringNew (ctx, data) {
    return fetch.rejectByBatchBringNew(data).then(res => {
      return res.data
    })
  },
  // 客服审核（通过）
  approvalByBatchBringNewSaler (ctx, data) {
    return fetch.approvalByBatchBringNewSaler(data).then(res => {
      let result = auditData.approvalByBatchBringNew(res.data)
      return result
    })
  },
  // 客服审核（驳回）
  rejectByBatchBringNewSaler (ctx, data) {
    return fetch.rejectByBatchBringNewSaler(data).then(res => {
      return res.data
    })
  },
  BringNewAuditDetail (ctx, id) {
    return fetch.BringNewAuditDetail(id).then(res => {
      let result = res.data
      result.genericReward = auditData.BringNewAuditDetail(res.data && res.data.genericReward)
      console.log(' result.genericReward ', result.genericReward)
      result.genericReward.mallOrderNumber = result.mallOrderNumber
      result.genericReward.mallOrderId = result.mallOrderId
      return result
    })
  },
  getWithdrawalsList (ctx, data) {
    return fetch.getWithdrawalsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getWithdrawalsList(result.data)
      return result
    })
  },
  withdrawalDetail (ctx, id) {
    return fetch.withdrawalDetail(id).then(res => {
      let result = auditData.withdrawalDetail(res.data)
      return result
    })
  },
  withdrawalComplete (ctx, ids) {
    return fetch.withdrawalComplete(ids).then(res => {
      return res.data
    })
  },
  withdrawalReject (ctx, data) {
    return fetch.withdrawalReject(data).then(res => {
      return res.data
    })
  },
  withdrawalsExport (ctx, data) {
    return fetch.withdrawalsExport(data).then(res => {
      return res
    })
  },
  updateRewardAfterRejected (ctx, data) {
    return fetch.updateRewardAfterRejected(data).then(res => {
      return res.data
    })
  },
  grantRewad (ctx, data) {
    return fetch.grantRewad(data).then(res => {
      return res
    })
  },
  customerGrantReward (ctx, data) {
    return fetch.customerGrantReward(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.customerGrantReward(result.data)
      return result
    })
  },
  batchrewardStatistics (ctx, data) {
    return fetch.batchrewardStatistics(data).then(res => {
      return res.data
    })
  },
  batchrewardStatisticsSaler (ctx, data) {
    return fetch.batchrewardStatisticsSaler(data).then(res => {
      return res.data
    })
  },
  batchManualRewardApprove (ctx, data) {
    return fetch.batchManualRewardApprove(data).then(res => {
      return res.data
    })
  },
  batchManualRewardReject (ctx, data) {
    return fetch.batchManualRewardReject(data).then(res => {
      return res.data
    })
  },
  oldCudtomerRemindPay (ctx, id) {
    return fetch.oldCudtomerRemindPay(id).then(res => {
      return res.data
    })
  },
  // 手动发放奖励-客服审批
  batchManualRewardApproveSaler (ctx, data) {
    return fetch.batchManualRewardApproveSaler(data).then(res => {
      return res.data
    })
  },
  // 手动发放奖励审核-客服驳回
  batchManualRewardRejectSaler (ctx, data) {
    return fetch.batchManualRewardRejectSaler(data).then(res => {
      return res.data
    })
  },
  genericRewardDetail (ctx, id) {
    return fetch.genericRewardDetail(id).then(res => {
      return fetch.getRewardBusinessType().then(Response => {
        let result = auditData.genericRewardDetail(res.data, Response.data)
        return result
      })
    })
  },
  flashBorrowList (ctx, data) {
    return fetch.flashBorrowList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.flashBorrowList(result.data)
      return result
    })
  },
  // 闪贷详情
  flashBorrowDetail (ctx, id) {
    return fetch.flashBorrowDetail(id).then(res => {
      let result = auditData.flashBorrowDetail(res.data)
      return result
    })
  },
  // 闪贷审核
  flashBorrowAudit (ctx, data) {
    return fetch.flashBorrowAudit(data).then(res => {
      return res.data
    })
  },
  flashBorrowComponent (ctx, data) {
    return fetch.flashBorrowComponent(data).then(res => {
      return res.data
    })
  },
  flashBorrowExport (ctx, data) {
    return fetch.flashBorrowExport(data).then(res => {
      return res
    })
  },
  getRewardBusinessType (ctx) {
    return fetch.getRewardBusinessType().then(res => {
      return res.data
    })
  },
  createRewardBusinessType (ctx, data) {
    return fetch.createRewardBusinessType(data).then(res => {
      return res.data
    })
  },
  getAllAuditList (ctx, data) {
    return fetch.getAllAuditList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getAllAuditList(result.data)
      return result
    })
  },
  getMedicalRewardList (ctx, data) {
    return fetch.getMedicalRewardList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getAllAuditList(result.data)
      return result
    })
  },
  exportAUditAll (ctx, data) {
    return fetch.exportAUditAll(data).then(res => {
      res.data.forEach(item => {
        item.businessDepartmentName = item.businessDepartmentName || '--'
      })
      return res
    })
  },
  exportMedicalRewardList (ctx, data) {
    return fetch.exportMedicalRewardList(data).then(res => {
      return res
    })
  },
  queryMerchantBalance (ctx, data) {
    return fetch.queryMerchantBalance(data).then(res => {
      let result = res.data
      result = auditData.bankCardBalance(result)
      return result
    })
  },
  getUserBalance (ctx, data) {
    return fetch.getUserBalance(data).then(res => {
      let result = auditData.getUserBalance(res.data)
      return result
    })
  },
  addUserBalance (ctx, data) {
    return fetch.addUserBalance(data).then(res => {
      return res.data
    })
  },
  deleteBalanceDetail (ctx, data) {
    return fetch.deleteBalanceDetail(data).then(res => {
      return res.data
    })
  },
  updateBalance (ctx, data) {
    return fetch.updateBalance(data).then(res => {
      return res.data
    })
  },
  getBalanceDetail (ctx, data) {
    return fetch.getBalanceDetail(data).then(res => {
      let result = auditData.getBalanceDetail(res.data)
      return result
    })
  },
  getBalanceList (ctx, data) {
    return fetch.getBalanceList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getBalanceList(result.data)
      return result
    })
  },
  refundMethod (ctx, id) {
    return fetch.refundMethod(id).then(res => {
      let result = auditData.refundMethod(res.data)
      return result
    })
  },
  refundBringNewReward (ctx, data) {
    return fetch.refundBringNewReward(data).then(res => {
      return res.data
    })
  },
  addUserWalletBalance (ctx, data) {
    return fetch.addUserWalletBalance(data).then(res => {
      return res
    })
  },
  AddBalance (ctx, data) {
    return fetch.AddBalance(data).then(res => {
      return res
    })
  },
  getDepartmentBalance (ctx, data) {
    return fetch.getDepartmentBalance(data).then(res => {
      return res
    })
  },
  getAllDepartmentBalance (ctx, data) {
    return fetch.getAllDepartmentBalance(data).then(res => {
      return res.data
    })
  },
  getEachBusinessDepartmentQuota (ctx, data) {
    return fetch.getEachBusinessDepartmentQuota(data).then(res => {
      return res.data
    })
  },
  noWithdrawalsAmount (ctx) {
    return fetch.noWithdrawalsAmount().then(res => {
      return res.data
    })
  },
  // 获取订金结算列表
  getDepositSettlementList (ctx, data) {
    return fetch.getDepositSettlementList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getDepositSettlementList(result.data)
      return result
    })
  },
  // 订金结算确认已入库
  confirmRecord (ctx, data) {
    return fetch.confirmRecord(data).then(res => {
      return res
    })
  },
  // 订金结算列表导出
  depositSettlementListExport (ctx, data) {
    return fetch.depositSettlementListExport(data).then(res => {
      return res.data
    })
  },
  // 获取手动发放积分列表
  getPointsRewardList (ctx, data) {
    return fetch.getPointsRewardList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getPointsRewardList(result.data)
      return result
    })
  },
  // 创建积奖励列表
  createPointsReward (ctx, data) {
    return fetch.createPointsReward(data).then(res => {
      return res.data
    })
  },
  // 获取积分奖励详情
  getPointsRewardsDetail (ctx, data) {
    return fetch.getPointsRewardsDetail(data).then(res => {
      res.data = auditData.getPointsRewardsDetail(res.data)
      return res.data
    })
  },
  pointsRewardsBatchAudit (ctx, data) {
    return fetch.pointsRewardsBatchAudit(data).then(res => {
      return res.data
    })
  },
  pointsRewardsBatchRejected (ctx, data) {
    return fetch.pointsRewardsBatchRejected(data).then(res => {
      return res.data
    })
  },
  manulRewardExport (ctx, data) {
    return fetch.manulRewardExport(data).then(res => {
      return res.data
    })
  },
  pointsRewardExport (ctx, data) {
    return fetch.pointsRewardExport(data).then(res => {
      return res.data
    })
  },
  // 获取扫码缴费记录列表
  getScanPaymentList (ctx, data) {
    return fetch.getScanPaymentList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = auditData.getScanPaymentList(result.data)
      return result
    })
  },
  // 扫码缴费导出接口
  scanPaymentExport (ctx, data) {
    return fetch.scanPaymentExport(data).then(res => {
      return res.data
    })
  }
}
